import React from "react";
import moonImg from "../assets/moonImg.png";
const Portfolio = () => {
  return (
    <div id="Portfolio" className="w-full mt-20 pt-20">
      <div className="flex flex-wrap ">
        <div className=" flex flex-col justify-center lg:w-1/2 w-full text-6xl lg:text-7xl font-bold text-center bg-gradient-to-r from-cyan-500 via-blue-700 to-indigo-600 bg-clip-text text-transparent">
          Our Latest
          <div>Portfolio</div>
          <div className=" flex flex-row justify-center w-full mb-10 mt-5">
            <div className="bg-[#0000ff] w-1 h-1 rounded-full mx-1"></div>
            <div className="bg-[#0000ff] w-1 h-1 rounded-full mx-1"></div>
            <div className="bg-[#0000ff] w-1 h-1 rounded-full mx-1"></div>
            <div className="bg-[#0000ff] w-24 h-1 rounded-full mx-1"></div>
          </div>
        </div>
        <div className="lg:w-1/2 w-full flex justify-start text-sm lg:text-xl text-center">
          Explore our captivating video portfolio showcasing mesmerizing <br />
          creations and compelling storytelling. Get inspired for your next{" "}
          <br />
          masterpiece and let us bring your video ideas to life with finesse{" "}
          <br />
          and flair.
        </div>
      </div>
      <div className="flex justify-center flex-row flex-wrap">
        <div className="flex flex-col m-5 w-full lg:w-fit ">
          <div className="my-5 flex justify-center items-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/bLVAACXMA80?si=8LPy8UAnOmfqoQdJ"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className=" aspect-video h-full "
            ></iframe>
          </div>
          <div className="my-5 flex justify-center items-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/SPHJTP-8Qvo?si=2OFQluHoyRlk8Fhe"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className="aspect-video
              h-full"
            ></iframe>
          </div>
          <div className="lg:my-5 flex justify-center items-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/Okj1mUlepjA?si=bUzPrTXSUCec-N2H"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className="aspect-video h-full"
            ></iframe>
          </div>
          <div className="lg:my-5 flex justify-center items-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/dc3kmwBDlzk?si=Xcnl6UQ9tOoNUhqP"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className="aspect-video h-full"
            ></iframe>
          </div>

          <div className="lg:my-5 flex justify-center items-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/ahKfLHADU5M?si=_Uni25BQWblcxSQY"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className="aspect-video
              h-full"
            ></iframe>
          </div>
        </div>
        <div className="flex flex-col m-5 w-full lg:w-fit ">
          <div className="my-5 flex justify-center items-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/AvWejRVF5RY?si=EHx0Xp4e4nveQntm"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className="aspect-video
              h-full"
            ></iframe>
          </div>
          <div className="my-5 flex justify-center items-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/QZU6C8ZHi2w?si=TeKRMYkTJZPiUHgd"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className="aspect-video
              h-full"
            ></iframe>
          </div>
          <div className="my-5 flex justify-center items-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/PYHiUdm_NuY?si=F4bchYBZudaMNEeM"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className="aspect-video
              h-full"
            ></iframe>
          </div>
          <div className="my-5 flex justify-center items-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/QDhxWZcCCNM?si=yBv04K_5mahzRPOO"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className="aspect-video
              h-full"
            ></iframe>
          </div>
          <div className="my-5 flex justify-center items-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/ECo959wvzmQ?si=ljbl7F99A9c0sEuH"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className="aspect-video
              h-full"
            ></iframe>
          </div>
        </div>

        <div className="hidden lg:block w-full">
          <div className="flex w-full justify-end  ">
            <div className="flex w-1/4 justify-center">
              <img
                src={moonImg}
                alt=""
                className="relative left-[-50px] top-[-90px] -z-10"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
